/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControlVendorRead } from '../models/ControlVendorRead';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ControlVendorLinksService {
    /**
     * Link Control To Vendor
     * @returns ControlVendorRead Successful Response
     * @throws ApiError
     */
    public static linkControlToVendorControlsControlIdVendorsVendorIdPost({
        controlId,
        vendorId,
        createdBy,
    }: {
        controlId: number,
        vendorId: number,
        createdBy?: (string | null),
    }): CancelablePromise<ControlVendorRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/controls/{control_id}/vendors/{vendor_id}',
            path: {
                'control_id': controlId,
                'vendor_id': vendorId,
            },
            query: {
                'created_by': createdBy,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Unlink Control From Vendor
     * @returns any Successful Response
     * @throws ApiError
     */
    public static unlinkControlFromVendorControlsControlIdVendorsVendorIdDelete({
        controlId,
        vendorId,
    }: {
        controlId: number,
        vendorId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/controls/{control_id}/vendors/{vendor_id}',
            path: {
                'control_id': controlId,
                'vendor_id': vendorId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Vendors For Control
     * @returns ControlVendorRead Successful Response
     * @throws ApiError
     */
    public static listVendorsForControlControlsControlIdVendorsGet({
        controlId,
    }: {
        controlId: number,
    }): CancelablePromise<Array<ControlVendorRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/controls/{control_id}/vendors',
            path: {
                'control_id': controlId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Controls For Vendor
     * @returns any Successful Response
     * @throws ApiError
     */
    public static listControlsForVendorControlsVendorsVendorIdControlsGet({
        vendorId,
    }: {
        vendorId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/controls/vendors/{vendor_id}/controls',
            path: {
                'vendor_id': vendorId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
